import { Button, Typography } from '@mui/material';
import React from 'react';
import {
  MdDelete,
  MdDownload,
  MdLockOpen,
  MdLockOutline,
} from 'react-icons/md';

import { DivBlockStyled, RootStyled, SectionStyled } from './index.styles';

export function AdminDetails() {
  return (
    <RootStyled>
      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          margin: '32px 0',
        }}
      >
        <Typography variant="h3" color="secondary">
          Visão detalhada do administrador
        </Typography>
        <Button variant="outlined" color="secondary">
          <MdDownload size={16} style={{ marginRight: 4 }} />
          Baixar todas as informações
        </Button>
      </div>
      <div style={{ color: '#fff' }}>
        <Typography variant="h3">Administradores</Typography>
        <div style={{ display: 'flex', gap: 32, margin: '24px 0' }}>
          <DivBlockStyled>
            <MdLockOutline size={20} color="lightgray" />
          </DivBlockStyled>
          <DivBlockStyled>
            <MdLockOpen size={20} color="lightgray" />
          </DivBlockStyled>
        </div>
      </div>
      <hr style={{ marginTop: 32 }} />
      <SectionStyled>
        <Typography variant="h5">Assinatura e cobrança</Typography>
        <div style={{ marginLeft: -15 }}>
          <p>
            <strong>Construtora:</strong> MG Engenharia
          </p>
          <p>mgengenharia@gmail.com</p>
          <p>Senha: *****</p>
        </div>
        <div className="links">
          <p>Enviar mensagem</p>
          <p>Alterar email da conta</p>
          <p>Alterar senha</p>
        </div>
      </SectionStyled>
      <hr />
      <SectionStyled>
        <Typography variant="h5">Detalhes do plano</Typography>
        <div>
          <p>
            <strong>Premium</strong>
          </p>
          <p>
            <strong>Obras iniciadas:</strong> 27
          </p>
          <p>
            <strong>Espaço utilizado:</strong> 16/20 GB
          </p>
        </div>
        <div className="links">
          <p>Alterar plano</p>
          <p style={{ color: 'transparent' }}>1</p>
          <p style={{ color: 'transparent' }}>1</p>
        </div>
      </SectionStyled>
      <hr />
      <SectionStyled>
        <Typography variant="h5">Assinatura e pagamento</Typography>
        <div style={{ marginLeft: -26 }}>
          <p>
            <strong>Data de assinatura:</strong> 01/02/2021
          </p>
          <p>
            <strong>Último pagamento:</strong> 01/11/2021
          </p>
        </div>
        <div className="links">
          <p />
        </div>
      </SectionStyled>
      <hr />
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          marginTop: 16,
        }}
      >
        <div />
        <Typography
          variant="h5"
          style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            color: '#FF8B9A',
          }}
        >
          <MdDelete color="#FF8B9A" size={20} />
          Deletar usuário
        </Typography>
      </div>
    </RootStyled>
  );
}
